export const GET_COMPANY_SUCCESS = 'GET_COMPANY_SUCCESS';
export const GET_COMPANY_FAILURE = 'GET_COMPANY_FAILURE';
export const GET_COMPANY_REQUEST = 'GET_COMPANY_REQUEST';
export const GET_PROFILE_SUCCESS = 'GET_PROFILE_SUCCESS';
export const GET_PROFILE_FAILURE = 'GET_PROFILE_FAILURE';
export const GET_PROFILE_REQUEST = 'GET_PROFILE_REQUEST';
const token = localStorage.getItem('token');



const getCompanies = (tenant) => {
    return async (dispatch) => {
        dispatch({ type: GET_COMPANY_REQUEST });
        try {
            const response = await fetch(`${tenant.getApiUrl('company')}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to retrieve companies');
            }
            const data = await response.json();
            dispatch({ type: GET_COMPANY_SUCCESS, payload: data.response || [] });
        } catch (error) {
            dispatch({ type: GET_COMPANY_FAILURE, payload: error.message });
        }
    };
}


const getAllJobProfiles = (tenant) => {
    return async (dispatch) => {
        dispatch({ type: GET_PROFILE_REQUEST });
        try {
            const response = await fetch(`${tenant.getApiUrl('jobProfile')}`, {
                method: 'GET',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            });
            if (!response.ok) {
                throw new Error('Failed to retrieve companies');
            }
            const data = await response.json();
            dispatch({ type: GET_PROFILE_SUCCESS, payload: data.response || [] });
        } catch (error) {
            dispatch({ type: GET_PROFILE_FAILURE, payload: error.message });
        }
    };
}

const getUsers = async (tenant) => {
    try {
        const { user, getInitialApiUrl } = tenant;
        const API = `${getInitialApiUrl('auth', 'users')}`;
        const res = await fetch(`${API}?id=${user.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        if (!res.ok) {
            throw new Error(`Failed to fetch users: ${res.statusText}`);
        }
        const data = await res.json();
        
        return data.response || [];
    } catch (error) {
        console.error('Error fetching users:', error);
    }
}

const getDeletedUsers = async (tenant) => {
    try {
        const { user, getInitialApiUrl } = tenant;
        const API = `${getInitialApiUrl('auth', 'users')}/deleted`;
        const res = await fetch(`${API}?id=${user.id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        if (!res.ok) {
            throw new Error(`Failed to fetch deleted users: ${res.statusText}`);
        }
        const data = await res.json();

        return data.response || [];
    } catch (error) {
        console.error('Error fetching deleted users:', error);
    }
}

const getUserById = async (tenant, id) => {
    try {
        const { getInitialApiUrl } = tenant;
        const API = `${getInitialApiUrl('auth', 'user')}`;
        const res = await fetch(`${API}/id?id=${id}`, {
            method: 'GET',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${localStorage.getItem('token')}`,
            },
        });
        if (!res.ok) {
            return null;
        }
        const data = await res.json();
        return data.response || null;
    } catch (error) {
        console.error('Error fetching users:', error);
    }
}



export { getCompanies, getAllJobProfiles, getUsers, getUserById, getDeletedUsers };